import { render, staticRenderFns } from "./addLabeltemplate.vue?vue&type=template&id=3a6dcaaf&scoped=true"
import script from "./addLabeltemplate.vue?vue&type=script&lang=js"
export * from "./addLabeltemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6dcaaf",
  null
  
)

export default component.exports